/* eslint-disable react/prefer-stateless-function */
import React, { Component } from "react";
import PropTypes from "prop-types";

import { NAMESPACE } from "../../namespace";
import "./Content.css";

class Content extends Component {
  // We could put some logic to link any content divs with
  // the state manager to make things DRY

  static propTypes = {
    /**
     * ClassName for the div. Appended with .content
     */
    className: PropTypes.string,
  };

  static defaultProps = {
    className: "",
  };

  render() {
    const { className } = this.props;
    return (
      <div className={`${NAMESPACE}Content ${className}`.trim()}>
        {this.props.children}
      </div>
    );
  }
}

export default Content;
